<template>
  <v-navigation-drawer app dark right v-model="drawer">
    <v-list dense flat nav>
      <v-list-item>
        <v-list-item-title>{{ code + " - " + currentCompany + " - " + currentWarehouse }}</v-list-item-title>
      </v-list-item>
      <v-list-item to="/Profile">
        <v-list-item-action><v-icon>far fa-user</v-icon></v-list-item-action>
        <v-list-item-title>Profil</v-list-item-title>
      </v-list-item>
      <v-list-group v-for="(company, index) in companies" :key="company + '-' + index" active-class="tesfriRaspberry--text" no-action>
        <template v-slot:activator>
          <v-list-item-title>{{ company.code }}</v-list-item-title>
        </template>

        <v-list-item
          v-for="(warehouse, index) in company.warehouses"
          :key="warehouse.code + '-' + index"
          v-on:click="
            updateCurrentCompanyWarehouse({ companyCode: company.code, warehouseCode: warehouse.code }).then(d => redirectToHome())
          "
        >
          <v-list-item-title v-text="warehouse.code"></v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2">
        <v-btn color="tesfriRaspberry" block @click="handleLogout">Déconnexion</v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "right-drawer",
  computed: {
    ...mapState("userContext", ["rights", "currentWarehouse", "currentCompany", "warehouses", "code"]),
    drawer: {
      get() {
        return this.$store.getters.rightDrawerState;
      },
      set(state) {
        return this.$store.commit("CHANGE_RIGHT_DRAWER", state);
      }
    },
    companies: function() {
      // reformatage des infomations company warehouse en regroupant par company
      const result = [];
      const map = new Map();
      this.warehouses.forEach(item => {
        if (!map.has(item.companyCode)) {
          map.set(item.companyCode, true); // set any value to Map
          result.push({
            code: item.companyCode,
            warehouses: this.warehouses
              .filter(x => x.companyCode == item.companyCode)
              .map(x => {
                return { code: x.warehouseCode, name: x.warehouseName };
              })
          });
        }
      });

      return result;
    }
  },
  methods: {
    ...mapActions("userContext", ["updateCurrentWarehouse", "updateCurrentCompany", "updateCurrentCompanyWarehouse", "logout"]),
    redirectToHome() {
      // redirection vers la page d'accueil
      this.$router.go("/");
    },
    handleLogout() {
      const redirectUri = this.$route.fullPath;
      this.logout()
        .then(this.$router.push({ name: "login", query: { redirectUri: redirectUri } }))
        .catch(error => {
          //TODO : ajouter un message d'erreur sur la page
          Vue.$log.error(error);
        });
    }
  }
};
</script>
